module.exports = __webpack_public_path__ + "static/media/1442319221_resized.771769da.png";